const PINBOARD_REGISTRY = [
  {
    group: 'trends',
    label: 'Trends',
    widgets: [
      { name: 'new-arrivals', title: 'New Arrivals', sortable: false },
      { name: 'biggest-gains', title: 'Biggest Gains', sortable: true },
      { name: 'biggest-losses', title: 'Biggest Losses', sortable: true },
    ],
  },
  {
    group: 'markets',
    label: 'Markets',
    widgets: [
      { name: 'watchlist', title: 'Watchlist', sortable: true },
      { name: 'session-history', title: 'Session List', sortable: true },
      { name: 'portfolio', title: 'Portfolio', sortable: false },
    ],
  },
  {
    group: 'social',
    label: 'Social',
    widgets: [{ name: 'market-discussion', title: 'Discussion', side: 'right', sortable: false }],
  },
];

export default PINBOARD_REGISTRY;
